module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assign-l2/assign-l2.component.css
// module id = ./src/app/assign-l2/assign-l2.component.css
// module chunks = main